import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../actions/alert";
import { createLeadContact } from "../../../api/partnerLead";
import { getContactsList } from "../../../api/sales";
import ControlledTable from "../../../component/ControlledTable";
import { handleAxiosError } from "../../../config/action-config";
import { contactsListTable as tableDef } from "../../../config/grid-columns-defs";

export default function ViewLeadsContacts({ leadId }) {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [totalCount, setTotalCount] = useState(0);
  const [rows, setRows] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [itemDialog, setItemDialog] = useState(false);
  const getRows = async (numRows, startRow) => {
    return getContactsList(
      { lead_id: leadId, limit: numRows, offset: startRow },
      user.token
    )
      .then((res) => {
        setTotalCount(parseInt(res.data.total) === 0 ? -1 : res.data.total);
        return res.data.records;
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        return [];
      });
  };
  const refreshTable = async () => {
    try {
      const { data } = await getContactsList(
        { lead_id: leadId, limit: 10, offset: 0 },
        user.token
      );
      setTotalCount(parseInt(data.total) === 0 ? -1 : parseInt(data.total));
      setRows(data.records);
    } catch (err) {
      handleAxiosError(err, dispatch);
    }
  };

  const onItemDialogSubmit = async (postData) => {
    postData.lead_id = leadId;
    try {
      const { data } = await createLeadContact(postData, user.token);
      refreshTable();
      dispatch(showAlert(data.msg));
      setItemDialog(false);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };

  return (
    <div>
      {user.role === "Partner" ? (
        <Box sx={{ display: "flex", columnGap: 1, p: 2, borderBottom: 1 }}>
          <Button
            variant="contained"
            style={{ padding: "5px 7px" }}
            onClick={() => {
              setItemDialog(true);
            }}
            className="blue-button"
          >
            Add Contact
          </Button>
        </Box>
      ) : (
        <></>
      )}

      <div className="ag-theme-material" style={{ height: "300px" }}>
        <ControlledTable
          rows={rows}
          columnDefs={tableDef}
          getRows={getRows}
          totalCount={totalCount}
          onChange={setRows}
          onPageNumberChange={setPageNumber}
          pageSize={10}
          pageNumber={pageNumber}
          pagination={true}
          hasActionButtons={false}
        />
      </div>
      <ItemDialogContactsTab
        open={itemDialog}
        setOpen={setItemDialog}
        onSubmit={onItemDialogSubmit}
      />
    </div>
  );
}
const emptyItemData = {
  lead_id: "",
  firstname: "",
  lastname: "",
  email: "",
  contact: "",
  designation: "",
  linkedin_url: "",
  address: "",
};
function ItemDialogContactsTab({ open, setOpen, onSubmit }) {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ defaultValues: emptyItemData });

  const submit = (data) => {
    onSubmit(data);
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
       // setOpen(false);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ textTransform: "capitalize" }}>
        Lead Contact
      </DialogTitle>
      <DialogContent>
        <Grid container width={500} spacing={1} py={1}>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              type="text"
              label="First Name"
              className="name-textfeild"
              name="firstname"
              fullWidth
              inputRef={register({
                required: "First Name is required.",
              })}
              required
              error={Boolean(errors.firstname)}
              helperText={errors.firstname?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              type="text"
              label="Last Name"
              className="name-textfeild"
              name="lastname"
              fullWidth
              inputRef={register({
                required: "Last Name is required.",
              })}
              required
              error={Boolean(errors.lastname)}
              helperText={errors.lastname?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              type="text"
              label="Email"
              name="email"
              fullWidth
              inputRef={register({
                required: "Email Address  is required.",
                pattern: {
                  value:
                    /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                  message: "Please enter a valid e-mail address.",
                },
              })}
              required
              error={Boolean(errors.email)}
              helperText={errors.email?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              type="text"
              label="Contact"
              name="contact"
              fullWidth
              inputProps={{ maxLength: 10 }}
              inputRef={register({
                required: "Contact Number is required.",
                validate: (value) =>
                  value.length > 9 || "Please enter a valid number",
              })}
              required
              error={Boolean(errors.contact)}
              helperText={errors.contact?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              type="text"
              label="Designation"
              name="designation"
              fullWidth
              inputRef={register({
                required: "Designation is required.",
              })}
              required
              error={Boolean(errors.designation)}
              helperText={errors.designation?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              type="text"
              label="LinkedIn url"
              name="linkedin_url"
              fullWidth
              inputRef={register({
                required: "LinkedIn URL is required.",
                pattern: {
                  value:
                    /^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(pub|in|profile)/,
                  message: "Please enter a valid linkedin url.",
                },
              })}
              required
              error={Boolean(errors.linkedin_url)}
              helperText={errors.linkedin_url?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              type="text"
              label="Address"
              name="address"
              fullWidth
              multiline={true}
              rows={3}
              inputRef={register({
                required: "Adress is required.",
              })}
              required
              error={Boolean(errors.address)}
              helperText={errors.address?.message}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpen(false);
          }}
          className="cancel-button"
        >
          Cancel
        </Button>
        <Button className="blue-button" onClick={handleSubmit(submit)}>{"Submit"}</Button>
      </DialogActions>
    </Dialog>
  );
}
